import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const Loan = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  // ✅ Summary Data
  const summary = [
    { title: "Total Loan", value: "$25,000", color: "#4f46e5" },
    { title: "Total Paid", value: "$10,000", color: "#16a34a" },
    { title: "Total Unpaid", value: "$15,000", color: "#dc2626" },
    { title: "Monthly EMI", value: "$1,200", color: "#f59e0b" },
  ];

  // ✅ Table Data
  const data = [
    {
      key: "1",
      name: "Antony",
      amount: "$5000",
      month: "Jan 2024",
      created: "01 Jan 2024",
      oneTime: "No",
      emi: "$500",
      paid: "$2000",
      status: "Active",
    },
    {
      key: "2",
      name: "Antony",
      amount: "$7000",
      month: "Feb 2024",
      created: "05 Feb 2024",
      oneTime: "Yes",
      emi: "$0",
      paid: "$7000",
      status: "Paid",
    },
    {
      key: "3",
      name: "Antony",
      amount: "$3000",
      month: "Mar 2024",
      created: "10 Mar 2024",
      oneTime: "No",
      emi: "$300",
      paid: "$900",
      status: "Pending",
    },
    {
      key: "4",
      name: "Antony",
      amount: "$10000",
      month: "Apr 2024",
      created: "15 Apr 2024",
      oneTime: "No",
      emi: "$800",
      paid: "$4000",
      status: "Active",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  // ✅ Table Columns
  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Employee Name", dataIndex: "name" },
    { title: "Amount", dataIndex: "amount" },
    { title: "Month & Year", dataIndex: "month" },
    { title: "Created At", dataIndex: "created" },
    { title: "One Time Deduct", dataIndex: "oneTime" },
    { title: "EMI", dataIndex: "emi" },
    { title: "Paid", dataIndex: "paid" },
    { title: "Status", dataIndex: "status" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      
      {/* ✅ Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        {summary.map((card, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderLeft: `5px solid ${card.color}`,
            }}
          >
            <span style={{ color: "#6b7280", fontSize: "14px" }}>
              {card.title}
            </span>
            <h2 style={{ margin: 0, color: card.color }}>
              {card.value}
            </h2>
          </div>
        ))}
      </div>

      {/* ✅ Table */}
      <CustomTable
        title="Loan List"
        columns={columns}
        data={filteredData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSearch={setSearchText}
      />
    </div>
  );
};

export default Loan;